// MIDAS V3 — History sort dropdown (Phase 5)
//
// Two-state toggle: "Newest" (desc) ↔ "Oldest" (asc). Renders as a small
// button — clicking flips the order. Per Phase 5 spec, sort is purely
// client-side reverse of the threads array, no server param.
//
// Spec calls for a ▾ dropdown. To keep this MUI-free + simple, we use a
// button that toggles between the two values; the chevron is decorative.
// If we ever need a real multi-option dropdown, swap to a Radix Select.
//
// No MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

export type V3HistorySortOrder = "desc" | "asc";

interface MidasHistorySortV3Props {
  value: V3HistorySortOrder;
  onChange: (next: V3HistorySortOrder) => void;
  /** Localised "Najnovšie" / "Newest". */
  newestLabel: string;
  /** Localised "Najstaršie" / "Oldest". */
  oldestLabel: string;
}

const MidasHistorySortV3: React.FC<MidasHistorySortV3Props> = ({
  value,
  onChange,
  newestLabel,
  oldestLabel,
}) => {
  const label = value === "desc" ? newestLabel : oldestLabel;
  const ariaLabel = value === "desc" ? newestLabel : oldestLabel;

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={() => onChange(value === "desc" ? "asc" : "desc")}
      style={{
        height: 28,
        padding: "0 10px",
        fontSize: 12.5,
        fontFamily: "inherit",
        borderRadius: 999,
        background: "var(--midas-v3-card)",
        color: "var(--midas-v3-ink-2)",
        border: "1px solid var(--midas-v3-border)",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
        transition: "background-color .12s ease, border-color .12s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "var(--midas-v3-card-2)";
        e.currentTarget.style.borderColor = "var(--midas-v3-accent-line)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "var(--midas-v3-card)";
        e.currentTarget.style.borderColor = "var(--midas-v3-border)";
      }}
    >
      <span aria-hidden="true">↕</span>
      <span>{label}</span>
      <span aria-hidden="true" style={{ marginLeft: 2 }}>
        ▾
      </span>
    </button>
  );
};

export default MidasHistorySortV3;
